export default __webpack_public_path__ + "static/media/PompCWO1.53141e56.png";